export const Tumblr = ({ width = '32', height = '39', color = 'white' }) => {
  return (
    <svg
      width={width}
      height={height}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 291.32 291.32"
      xmlSpace="preserve"
    >
      <g>
        <path
          style={{ fill: color }}
          d="M182.074,180.254L182.074,180.254h-2.731h-0.91h-18.207c0,0-0.91,0-0.91-0.91s0-1.821,0-3.641v-33.684
            c0,0,0-0.91,0.91-0.91h24.58c0,0,0.91,0,0.91-0.91v-34.594c0,0,0-0.91-0.91-0.91h-24.58c0,0-0.91,0-0.91-0.91V71.009
            c0,0,0-0.91-0.91-0.91h-19.118h-6.373h-17.297c-2.731,0-6.373,2.731-7.283,6.373c-1.821,17.297-10.014,28.222-25.49,32.773
            l-0.91,0.91c0,0,0,0,0,0.91v30.042c0,0,0,0.91,0.91,0.91H94.68l0,0h3.641c0,0,0,28.222,0,36.415
            c0,29.132,20.028,43.698,58.264,43.698c15.476,0,30.042-5.462,35.505-11.835l0.91-0.91L182.074,180.254z M184.805,207.565
            c-4.552,4.552-14.566,8.193-23.67,8.193h-0.91l0,0c-30.953,0-39.146-23.67-39.146-37.325v-42.787c0,0,0-0.91-0.91-0.91h-14.566
            c0,0-0.91,0-0.91-0.91v-19.118v-0.91c15.476-6.373,24.58-18.207,27.311-37.325c0-0.91,0.91-0.91,0.91-0.91h20.028
            c0,0,0.91,0,0.91,0.91v33.684c0,0,0,0.91,0.91,0.91h24.58c0,0,0.91,0,0.91,0.91v22.759c0,0,0,0.91-0.91,0.91h-24.58
            c0,0-0.91,0-0.91,0.91v40.056c0,9.104,4.552,13.656,12.745,13.656c3.641,0,7.283-0.91,10.924-1.821h0.91L184.805,207.565
            C184.805,206.654,184.805,206.654,184.805,207.565z"
        />
      </g>
    </svg>
  );
};
